export const DEFAULT_TRACK_ENDPOINT = 'https://mall.ydjia.cn/webtrack/behavior';

/**
 * 海典埋点官方数据源标识（_dataSource）规范枚举
 */
export const DataSource = {
  // C端/移动端商城与小程序
  /** 1: 微商城【H5+小程序】 */
  MALL: '1',
  /** 2: 随心看小程序 */
  SUI_XIN_KAN_MP: '2',
  /** 3: 药事云小程序 */
  YAO_SHI_YUN_MP: '3',
  /** 80: 随心看h5 */
  SUI_XIN_KAN_H5: '80',

  // B端/商户后台及中台业务系统
  /** 90: 商户后台B端 */
  MERCHANT_ADMIN: '90',
  /** 9094: 商户后台OMS【特定业务使用的业务项目端口作为标识的】 */
  MERCHANT_ADMIN_OMS: '9094',
  /** 9096: 商户后台商品中心 */
  MERCHANT_ADMIN_GOODS_CENTER: '9096',
  /** 9099: 商户后台AI客服助手 */
  MERCHANT_ADMIN_AI_ASSISTANT: '9099',

  // 运营平台、厂家、SaaS 及服务商系统
  /** 100: 四季蝉厂家小程序 */
  SI_JI_CHAN_MP: '100',
  /** 101: HC运营平台 */
  HC_OPERATION_PLATFORM: '101',
  /** 102: sass待办任务-B端 */
  SAAS_TODO_B: '102',
  /** 103: 鹰眼H5端 */
  YING_YAN_H5: '103',
  /** 104: 服务商后台 */
  SERVICE_PROVIDER_ADMIN: '104',
} as const;

/** 数据源值类型，兼容官方枚举常量以及业务自定义的字符串或数字 */
export type DataSourceValue = (typeof DataSource)[keyof typeof DataSource] | string | number;
